<template>
  <div class="wrapper">
    <nav class="my_order_nav">
      <span :class="[selectTab==0?'cur':'']" @click="selectTab = 0">活动</span>
      <span :class="[selectTab==1?'cur':'']" @click="selectTab = 1">会议室</span>
      <span :class="[selectTab==2?'cur':'']" @click="selectTab = 2">办公耗材</span>
    </nav>
    <div class="main_list">
      <activity-list v-show="selectTab == 0" :selectTab="selectTab"></activity-list>
      <meeting-list v-show="selectTab == 1" :selectTab="selectTab"></meeting-list>
      <office-list v-show="selectTab == 2" :selectTab="selectTab"></office-list>
    </div>
  </div>
</template>

<script>
import ActivityList from './components/activityList';
import MeetingList from './components/meetingList';
import OfficeList from './components/officeList';
export default {
  name: 'myOrder',
  components: {
    ActivityList,
    MeetingList,
    OfficeList
  },
  data () {
    return {
      selectTab: 0
    }
  },
  watch: {
    $route (to, from) {
      if (from.name === 'mall' || from.name === 'goodsExchange') {
        this.selectTab = 2;
      } else if (from.name === 'meeting') {
        this.selectTab = 1;
      }else if (from.name === 'officeConfirmOrder'){
        this.selectTab = 2;
      }
    }
  },
  created () {
    if (this.$route.query.come == "meeting") {
      this.selectTab = 1;
    }else if (this.$route.query.come === 'office'){
        this.selectTab = 2;
      }
  }
};
</script>


<style scoped lang="less">
@import "../../assets/css/common.less";
.wrapper{
  height:100vh;
  .flex(column);
  background:@colore;
}
.my_order_nav{
  position: fixed;
  z-index:333;
  top:0;left:0;right:0;
  height:88px;
  background:#fff;
  .flex();
  justify-content: center;
  align-items: center;
  span{
    display: block;
    width:140px;
    height:48px;
    box-sizing:border-box;
    text-align: center;
    line-height:48px;
    color:#333;
    .fontSize(14px);
    .border();
    &:first-child{
      border-radius:6px 0px 0px 6px;
    }
    &:last-child{
      border-radius:0px 6px 6px 0px;
    }
    &:nth-child(2){
      border-left:0;
      border-right:0;
    }
    &.cur{
      background:@color17;
      .border(@color17);
      color:#fff;
    }
  }
}
.main_list{
  margin-top:88px;
  flex:1;
}
</style>
